// extracted by mini-css-extract-plugin
export default {"undo-wrapper":"undoPopup_undo-wrapper__zLZP5","undo-action":"undoPopup_undo-action__1BpKw","undo-wrapper-title":"undoPopup_undo-wrapper-title__c93RL"};